<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54.4299 43.73H28.0999C24.8359 43.73 22.1899 46.376 22.1899 49.64V69.8C22.1899 73.064 24.8359 75.71 28.0999 75.71H54.4299C57.6939 75.71 60.3399 73.064 60.3399 69.8V49.64C60.3399 46.376 57.6939 43.73 54.4299 43.73Z"
      fill="#CB80DE"
    />
    <path
      d="M34.9501 104.98C40.5502 104.98 45.0901 100.44 45.0901 94.84C45.0901 89.2398 40.5502 84.7 34.9501 84.7C29.3499 84.7 24.8101 89.2398 24.8101 94.84C24.8101 100.44 29.3499 104.98 34.9501 104.98Z"
      fill="#CB80DE"
    />
    <path
      d="M98.5299 104.98C104.13 104.98 108.67 100.44 108.67 94.84C108.67 89.2398 104.13 84.7 98.5299 84.7C92.9297 84.7 88.3899 89.2398 88.3899 94.84C88.3899 100.44 92.9297 104.98 98.5299 104.98Z"
      fill="#CB80DE"
    />
    <path
      d="M49.59 23H36.16C34.1442 23 32.51 24.6342 32.51 26.65V40.08C32.51 42.0958 34.1442 43.73 36.16 43.73H49.59C51.6058 43.73 53.24 42.0958 53.24 40.08V26.65C53.24 24.6342 51.6058 23 49.59 23Z"
    />
    <path
      d="M118.01 62.34L103.56 39.47C102.3 37.5 100.12 36.31 97.78 36.31H75.47C71.68 36.31 68.6 39.39 68.6 43.18V66.19H14.41C10.87 66.19 8 69.06 8 72.6V84.68C8 88.22 10.87 91.09 14.41 91.09H113.55C117.37 91.09 120.46 88 120.46 84.18V70.8C120.46 67.81 119.61 64.88 118.01 62.35V62.34Z"
    />
    <path
      d="M118.01 62.34L107.64 45.92L107.31 45.41C106.5 44.36 105.35 43.72 102.13 43.72H83.69C81.92 43.72 80.48 45 80.48 46.57V61.05C80.48 62.63 81.92 63.9 83.69 63.9H118.87C118.61 63.36 118.33 62.83 118.01 62.32V62.34Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'LightTruckInsurance'
  }
</script>
